(() => {
  const clearSelect = (select) => {
    if (!select) return;

    Array.from(select.options).forEach(option => {
      if (option.value) {
        select.removeChild(option);
      }
    });

    select.value = '';
    select.disabled = true;
  }

  const populateSelect = (select, locations) => {
    if (!select) return;

    clearSelect(select);

    Object.values(locations).forEach((location) => {
      const option = document.createElement('option');
      option.value = location.id;
      option.textContent = location.name;
      if(location.slug) option.dataset.slug = location.slug;
      select.appendChild(option);
    });

    select.disabled = false;
  }

  document.querySelectorAll('.location-selector-form').forEach((form) => {
    const countrySelector = form.querySelector('select[name="country"]');
    const provinceSelector = form.querySelector('select[name="province"]');
    const venueSelector = form.querySelector('select[name="venue"]');

    const locations = get_locations(!!venueSelector);

    let settingFilter = false;
    
    populateSelect(countrySelector, locations);

    countrySelector.addEventListener('change', () => {
      const selectedCountry = countrySelector.value;

      if(selectedCountry != ''){
        const options = locations[selectedCountry]['children'];
        populateSelect(provinceSelector, options);
        
        if(!venueSelector){
          const selectedCountrySlug = countrySelector.options[countrySelector.selectedIndex]?.dataset.slug;
          const url = new URL(window.location.href);
          url.searchParams.delete('province');
          url.searchParams.set('country', selectedCountrySlug);
          if(url.toString() != window.location.href && !settingFilter){
            window.history.pushState({}, '', url);
            window.dispatchEvent(new Event('LocationSelectorStateChanged'));
          }
        }
      }else{
        clearSelect(provinceSelector);
        
        if(!venueSelector){
          const url = new URL(window.location.href);
          url.searchParams.delete('country');
          url.searchParams.delete('province');
          if(url.toString() != window.location.href && !settingFilter){
            window.history.pushState({}, '', url);
            window.dispatchEvent(new Event('LocationSelectorStateChanged'));
          }
        }
      }

      clearSelect(venueSelector);
    });

    provinceSelector.addEventListener('change', () => {
      const selectedCountry = countrySelector.value;
      const selectedProvince = provinceSelector.value;

      if(selectedProvince){
        const optionIds = locations[selectedCountry]['children'][selectedProvince]['venues'];
        const options = [];

        for (const optionId of optionIds){
          const venue = get_venue_info(optionId);
          if(venue){
            options.push(venue);
          }
        }
        
        if(venueSelector){
          populateSelect(venueSelector, options);
        }else{
          const selectedProvinceSlug = provinceSelector.options[provinceSelector.selectedIndex]?.dataset.slug;
          const url = new URL(window.location.href);
          url.searchParams.delete('country');
          url.searchParams.set('province', selectedProvinceSlug);
          if(url.toString() != window.location.href && !settingFilter){
            window.history.pushState({}, '', url);
            window.dispatchEvent(new Event('LocationSelectorStateChanged'));
          }
        }
      }else{
        clearSelect(venueSelector);

        if(!venueSelector){
          const url = new URL(window.location.href);
          url.searchParams.delete('province');
          if(selectedCountry){
            const selectedCountrySlug = countrySelector.options[countrySelector.selectedIndex]?.dataset.slug;
            url.searchParams.set('country', selectedCountrySlug);
          }
          if(url.toString() != window.location.href && !settingFilter){
            window.history.pushState({}, '', url);
            window.dispatchEvent(new Event('LocationSelectorStateChanged'));
          }
        }
      }
    });

    venueSelector?.addEventListener('change', () => {
      const selectedVenue = venueSelector.value;

      if(selectedVenue){
        set_venue(selectedVenue);
      }
    });

    const updateSelectedLocationByUrl = () => {
      const url = new URL(window.location.href);
      const selectedCountry = url.searchParams.get('country');
      const selectedProvince = url.searchParams.get('province');

      settingFilter = true;

      Object.values(locations).forEach(country => {
        if(selectedCountry){
          if(selectedCountry == country.slug){
            countrySelector.value = country.id;
            countrySelector.dispatchEvent(new Event('change'));
          }
        }else{
          Object.values(country.children || {}).forEach(province => {
            if(selectedProvince == province.slug){
              countrySelector.value = country.id;
              countrySelector.dispatchEvent(new Event('change'));

              provinceSelector.value = province.id;
            }
          });
        }
      });

      settingFilter = false;
    }

    const updateSelectedLocationByVenue = () => {
      const venue = get_venue();
      if (venue) {
        Object.values(locations).forEach(country => {
          Object.values(country.children || {}).forEach(province => {
            Object.values(province.venues || {}).forEach(v => {
              if (v == venue) {
                countrySelector.value = country.id;
                countrySelector.dispatchEvent(new Event('change'));

                provinceSelector.value = province.id;
                provinceSelector.dispatchEvent(new Event('change'));

                if(venueSelector){
                  venueSelector.value = v;
                }
              }
            });
          });
        });
      }
    }
    
    const updateSelectedLocation = (force = false) => {
      const url = new URL(window.location.href);

      if(venueSelector || !(url.searchParams.get('country') || url.searchParams.get('province')) || force){
        updateSelectedLocationByVenue();
      }else{
        updateSelectedLocationByUrl();
      }
    }
    updateSelectedLocation();

    if(!venueSelector){
      window.addEventListener('popstate', function () {
        updateSelectedLocation();
      });
    }else{
      document.body.addEventListener('venueChanged', () => {
        settingFilter = true;
        updateSelectedLocation(true);
        settingFilter = false;
      });
    }

    if(!get_venue()){
      document.body.addEventListener('venueChanged', () => {
        updateSelectedLocation();
      }, { once: true });
    }

    const locateButton = form.querySelector('.location-selector-locate');
    locateButton.addEventListener('click', (event) => {
      event.preventDefault();
      locateButton.disabled = true;
      
      document.body.addEventListener('venueChanged', () => {
        updateSelectedLocation(true);
      }, { once: true });

      set_venue_by_coordinates(() => {
        locateButton.disabled = false;
      });
    });
    
    form.querySelector('.location-selector-clear')?.addEventListener('click', (event) => {
      event.preventDefault();
      
      countrySelector.value = '';
      countrySelector.dispatchEvent(new Event('change'));
    });
  });
})();